<template>
  <div class="legend-container">
    <map-legend-item
      v-for="item in legendItems"
      :symbol="item.symbol"
      :label="item.label"
      :key="item.value"
    ></map-legend-item>
  </div>
</template>

<script>
import MapLegendItem from '@/components/map-legend-item';

export default {
  id: 'MapLegend',
  components: { MapLegendItem },
  props: ['legendItems']
};
</script>

<style scoped></style>
